import React from "react";

import MemberType from "bodycodi/cmap/app/components/common/MemberType";
import default_customer_profile_48 from "bodycodi/cmap/app/svg/default_customer_profile_48.svg";
import icon_right_arrow_small from "bodycodi/cmap/app/svg/icon_right_arrow_small.svg";
import icon_checkbox_on from "bodycodi/cmap/app/svg/icon_checkbox_on.svg";
import icon_checkbox_off from "bodycodi/cmap/app/svg/icon_checkbox_off.svg";
import { isEmpty, maskingMobile } from "bodycodi/cmap/app/js/common";

type MemberProp = {
  d: any;
  from: string;
  isChecked: boolean;
  onClickMember: any;
};

const Member = ({ d, from, isChecked, onClickMember }: MemberProp) => {
  const clickMember = () => {
    onClickMember(d);
  };

  return (
    <div className="member-mngt" onClick={clickMember}>
      <div className="profile-wrap">
        <img className="profile" src={d.imgUrl || d.imageUrl || default_customer_profile_48} />
        {d.entranceMemberYn === "Y" && <div className="entrance"></div>}
      </div>
      <div className="text">
        <div className="title">
          <div className="bold">{d.name}</div>
          <MemberType
            appointmentMemberYn={d.appointmentMemberYn}
            chargeMemberYn={d.chargeMemberYn}
            isSmall
          />
        </div>
        <div className="desc">
          <span>{maskingMobile(d.mobile)} &#183; </span>
          {d.age === 0 || isEmpty(d.age) ? (
            <span className="no-age">나이 미설정</span>
          ) : (
            <span>만 {d.age}세</span>
          )}
        </div>
      </div>
      {from === "schedule" && (
        <label className="choose-member-checkbox">
          <input
            type="radio"
            name="member"
            onChange={() => {
              return;
            }}
            checked={isChecked}
          />
          <span></span>
          <span></span>
        </label>
      )}
      {from === "management" && <img className="icon" src={icon_right_arrow_small} />}
      {from === "community" && (
        <img className="icon" src={isChecked ? icon_checkbox_on : icon_checkbox_off} />
      )}
    </div>
  );
};

export default Member;
